import { sizes } from '@lmc/common/constants'
import dayjs from 'dayjs'
import { filter, includes } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { HeaderSection, Spinner } from '../../../components/generic'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import {
  StockDiscrepanciesDateFilter,
  StockDiscrepanciesLogTable,
  StockDiscrepanciesResidentFilter
} from './components'

const renderHeader = () => <HeaderSection title="Stock Discrepancies" />

const renderFilters = (props) => {
  const {
    activeFilters,
    endDate,
    preferredPeopleNominative,
    residents,
    setActiveFilters,
    setEndDate,
    setStartDate,
    startDate
  } = props

  return (
    <div style={styles.filterContainer}>
      <StockDiscrepanciesDateFilter
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <StockDiscrepanciesResidentFilter
        activeFilters={activeFilters}
        preferredPeopleNominative={preferredPeopleNominative}
        residents={residents}
        setActiveFilters={setActiveFilters}
      />
    </div>
  )
}

const renderTable = (logs) => <StockDiscrepanciesLogTable logs={logs} />

export function StockDiscrepanciesReportScreen(props) {
  const {
    fetchLogs,
    fetchMedications,
    isLoading,
    logs,
    preferredPeopleNominative = 'Residents',
    residents
  } = props

  const [startDate, setStartDate] = React.useState(
    dayjs().subtract(14, 'days').startOf('day')
  )
  const [endDate, setEndDate] = React.useState(dayjs().endOf('day'))
  const [activeFilters, setActiveFilters] = React.useState({})
  const stateProps = {
    activeFilters,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setActiveFilters
  }

  React.useEffect(() => {
    fetchLogs(startDate, endDate)
    fetchMedications()
  }, [startDate, endDate])

  if (isLoading || !logs || !residents || !residents.length) return <Spinner />

  let filteredLogs =
    activeFilters.resident && activeFilters.resident.length
      ? filter(logs, (log) => includes(activeFilters.resident, log.resident.id))
      : logs

  // Filter logs based on the active date filters
  filteredLogs = filteredLogs.filter(({ timeLogged }) => {
    const date = dayjs(timeLogged)
    if (startDate && dayjs(date).isBefore(startDate)) return false
    if (endDate && dayjs(date).isAfter(endDate)) return false
    return true
  })

  return (
    <div style={styles.container}>
      {renderHeader()}
      {renderFilters({
        ...stateProps,
        preferredPeopleNominative,
        residents
      })}
      {renderTable(filteredLogs)}
    </div>
  )
}

StockDiscrepanciesReportScreen.propTypes = {
  fetchData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  logs: PropTypes.array.isRequired,
  residents: PropTypes.array.isRequired
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
    position: 'relative'
  },
  filterContainer: {
    display: 'flex',
    marginTop: 16
  },
  residentFilter: {
    marginLeft: 16
  }
}

const mapStateToProps = (state, props) => ({
  logs: Selectors.getDiscrepancyLogs(state),
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  residents: state.data.residents
})

const mapDispatchToProps = (dispatch) => ({
  fetchLogs: (startDate, endDate) =>
    dispatch(
      Operations.loadList(
        'logs',
        {
          from: dayjs(startDate).startOf('day').toISOString(),
          to: dayjs(endDate).endOf('day').toISOString(),
          stockDiscrepancy: true,
          deleted: false
        },
        false
      )
    ),
  fetchMedications: () =>
    dispatch(Operations.loadList('emar-resident-medications'))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockDiscrepanciesReportScreen)
